import { useState } from "react";
import {
    Box,
} from '@mui/material';
import {
    DataGrid,
} from '@mui/x-data-grid';
import EditLocationActionItem from "./EditLocationActionItem";
import LocationChip from "./LocationChip";
import { CustomFooter } from "./EditLocationTableFooter";
import NameDialog from "./NameDialog";
import { Trans } from "react-i18next";

function EditLocationTable({ locations, onCreate, onUpdate, onDelete, onMakeDefault }) {
    const [createDialogOpen, setCreateDialogOpen] = useState(false);
    
    const handleCreateLocation = async (name) => {
        onCreate(name);
    };

    const handleRenameLocation = async (location) => {
        onUpdate(location)
    };

    const handleOpenCreateDialog = () => {
        setCreateDialogOpen(true);
    };

    const columns = [
        {
            field: 'name',
            headerName: 'Name',
            flex: 0.5,
            editable: true,
        },
        {
            field: 'actions',
            headerName: '',
            flex: 0.2,
            sortable: false,
            renderCell: (params) => {
                const isDefaultLocation = params.row.isDefaultLocation;
                return isDefaultLocation ? (
                    <LocationChip isDefaultLocation={true} />
                ) : (
                    <EditLocationActionItem
                        onUpdateDefaultLocation={() => onMakeDefault(params.row.id)}
                        onDeleteLocation={() => onDelete(params.row.id)}
                    />
                );
            }
        },
    ];

    return (
        <Box>
            <Box sx={{ textAlign: 'left' }}>
                <DataGrid
                    initialState={{
                        sorting: {
                            sortModel: [{ field: 'name', sort: 'asc' }],
                        },
                    }}
                    sx={{ marginTop: 5 }}
                    columns={columns}
                    processRowUpdate={handleRenameLocation}
                    rows={locations}
                    slots={{
                        footer: CustomFooter
                    }}
                    slotProps={{
                        footer: {
                            handleOpenDialog: handleOpenCreateDialog,
                        }
                    }}
                />
            </Box>
            <NameDialog
                open={createDialogOpen}
                onClose={() => setCreateDialogOpen(false)}
                title={<Trans i18nKey="fügeEinenNeuenStandortHinzu" ns="instituteConfigurationPage">Füge einen neuen Standort hinzu</Trans>}
                description={<Trans i18nKey="gibDenNamenDesStandortsEin" ns="instituteConfigurationPage">Gib den Namen des Standorts ein, um ihn dem Institut hinzuzufügen.</Trans>}
                name={''}
                onSave={(value) => handleCreateLocation(value)}
            />
        </Box>
    );
};

export default EditLocationTable
